import {
  FormControl,
  Typography,
  Box,
} from "@mui/material"
import { DatePicker, StaticDatePicker } from "@mui/x-date-pickers"

type InputShowcaseProps = {
  size: "small" | "medium"
}

const DatePickersShowcase: React.FC<InputShowcaseProps> = ({ size }) => {

  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
        <Typography className="text-xl font-bold">
            DatePickers Showcase
        </Typography>
        <FormControl size={size} fullWidth className="">
            <DatePicker
                label={"Date Picker"}
                slotProps={{
                    textField: {
                        size: size,
                    },
                }}
            />
        </FormControl>
        <FormControl size={size} fullWidth>
            <DatePicker
                label={"Year Picker"}
                openTo="year"
                slotProps={{
                    textField: {
                        size: size,
                    },
                }}
            />

        </FormControl>
        <FormControl size={size} fullWidth>
            <StaticDatePicker/>
        </FormControl>
    </Box>
  )
}

export default DatePickersShowcase
